// extracted by mini-css-extract-plugin
export default {"root":"SecurePaymentsBadge_root__KtI25","poweredByStripeMark":"SecurePaymentsBadge_poweredByStripeMark__Jrx-m","shieldIcon":"SecurePaymentsBadge_shieldIcon__WmxKH"};